import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IWithdrawAmount,
  IWithdrawReview,
  IWithdrawConclusion,
  IWithdrawDetailsV2
} from './product-withdraw-types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}`
});

export function getWithdrawDetailsV2(
  productId: string,
  categoryId: string
): Promise<IWithdrawDetailsV2> {
  return http.get(
    `/transactions/v1/redemptions/product/${categoryId}/${productId}/info`
  );
}

export function getProductWithdrawAmount(
  productId: string,
  amount: number
): Promise<IWithdrawAmount> {
  return http.post(`/transactions/v1/withdrawals/product/amount`, {
    productId,
    amount
  });
}

export function getProductWithdrawReview(
  productId: string,
  amount: number
): Promise<IWithdrawReview> {
  return http.post(`/transactions/v1/withdrawals/product/preview`, {
    productId,
    amount
  });
}

export function makeProductWithdraw(
  productId: string,
  amount: number
): Promise<IWithdrawConclusion> {
  return http.post(`/transactions/v1/withdrawals/product`, {
    productId,
    amount
  });
}
